var _indexOfInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/index-of");

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (_indexOfInstanceProperty(excluded).call(excluded, key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose.js
// module id = 636
// module chunks = 0